import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { GlobalComponent } from '../global/global.component';
import { ErrorService } from '../error.service';
import { GeneralService } from './general.service';

@Injectable({
    providedIn: 'root'
})
export class CommonApiService extends Subject<DataStateChangeEventArgs> {
    private onDestroy$: Subject<void> = new Subject<void>();
    constructor(public general:GeneralService,private handler: HttpBackend, public http: HttpClient, public errorService: ErrorService, public toasterService: ToastrService, public global: GlobalComponent) { super(); }
    //.............................saveorUpdateFunctionwithResponseTypeJson........................................
    saveorUpdateFunctionwithResponseTypeJson(saveList, url): Observable<any> {
        return this.http.post(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................saveorUpdateFunctionwithResponseTypeText........................................
    saveorUpdateFunctionwithResponseTypeText(saveList, url): Observable<any> {
        return this.http.post(url, saveList, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................saveorUpdateFunctionFileSaverwithQueryString........................................
    saveorUpdateFunctionFileSaverwithQueryString(paramsData, url, saveFileName) {
        return this.http.post(url + paramsData, "", { responseType: 'blob' }).subscribe((data) => {
            FileSaver.saveAs(data, saveFileName)
        }
        )
    }
    //.............................saveorUpdateFunctionFileSaver........................................
    saveorUpdateFunctionFileSaver(data, url, saveFileName) {
        return this.http.post(url, data, { responseType: 'blob' }).subscribe((data) => {
            FileSaver.saveAs(data, saveFileName)
        },
        (err: HttpErrorResponse) => {
       
            if (err.status == 400) {
              this.toasterService.error("No Records Found");
            }
          }
        )
    }
    //...............................saveorUpdateFunctionResponseTypeAsBlob..................................//
    saveorUpdateFunctionResponseTypeAsBlob(data, url): Observable<any> {
        return this.http.post(url, data, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
     //...............................QueryStringWithResponseTypeJsonAsBlob..................................//
    QueryStringWithResponseTypeJsonAsBlob (data,params, url): Observable<any> {
        return this.http.post(url+params, data, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //...............................saveorUpdateFunctionwithParams..................................//
    saveorUpdateFunctionwithParams(params: URLSearchParams,url):Observable<any> {
        return this.http.post<any>(url + params, "", { observe: 'response' }).pipe(
          map(data => data.body),
          catchError(this.errorService.handleError)
        )
    }
     //.............................UpdateFunctionwithResponseTypeJson........................................
    UpdateFunctionwithResponseTypeJson(saveList, url): Observable<any> {
        return this.http.put(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................DeleteFunctionForGetHttp........................................
    DeleteFunctionForGetHttp(deleteList, url): Observable<any> {
        return this.http.get(url + deleteList, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    //.............................DeleteFunctionForPostHttp........................................
    DeleteFunctionForPostHttp(deleteList, url): Observable<any> {
        return this.http.post(url, deleteList, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    //.............................DeleteFunctionForDeleteHttp........................................
    DeleteFunctionForDeleteHttp(deleteList, url): Observable<any> {
        return this.http.delete(url + deleteList, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
        //.............................DeleteFunctionForPostHttpWthParams........................................
        DeleteFunctionForPostHttpWthParams(deleteList, url): Observable<any> {
            return this.http.post(url + deleteList,{}, { observe: 'response', responseType: "text" }).pipe(
                map(data => data.body),
                catchError(this.errorService.handleError)
            );
        }
    //.............................GetFunctionwithResponseTypeJson........................................
    GetFunctionwithResponseTypeJson(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    //.............................GetFunctionwithResponseTypeText........................................
    GetFunctionwithResponseTypeText(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    //.............................GetFunctionForFileSaver........................................
    GetFunctionForFileSaver(paramsData, url, saveFileName) {
        return this.http.get(url + paramsData, { responseType: 'blob' }).subscribe((res) => {
            if (res != null && res != undefined) {
                if (res.size != 0 && res != undefined && res.size != undefined) {
                    FileSaver.saveAs(res, saveFileName);
                }
                else {
                    this.toasterService.error("No Data Found");
                }
            }
            else 
            {
        this.toasterService.error("No Data Found");
            }
        }
        )
    }
    //...............................GetFunctionForResponseTypeAsBlob..................................//
    GetFunctionForResponseTypeAsBlob(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................QueryStringWithPost........................................
    QueryStringWithResponseTypeJson(List, params, url): Observable<number> {
        return this.http.post<number>(url + params, List, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................QueryStringWithPost........................................
    QueryStringWithResponseTypeText(List, params, url): Observable<any> {
        return this.http.post(url + params, List, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    //.............................outputValues........................................
    public outputValues(url, List, responseData, params): void {
        this.GetCallForGridTable(url, List, responseData, params).subscribe((x) => super.next(x)
        );
    }
    //.............................GetCallForGridTable........................................
    GetCallForGridTable(url, List, responseData, params): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>(url + params, List)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response[responseData.result],
                        count: response[responseData.count],
                        sumOfTotalHours: response[responseData.sumOfTotalHours]
                    })).pipe(map((e: any) => {
                        if (url == "api/SFTPDetail/GetSFTPCredentials") {
                            e?.result?.forEach(element => {
                                element.status=element?.isActive==true?"ACTIVE":"INACTIVE" ;
                            });            
                        }
                        if (url == "api/MonitorList/GetClientMonitor" || url == "api/MonitorList/GetEmployeeMonitor") {
                            e?.result?.forEach(element => {
                                element.colorCode=(element?.colorCode!=null&&element?.colorCode!=undefined&&element?.colorCode!='')?element.colorCode:"black";
                            });            
                        }
                        if (url == "api/AddTimeNonBillable/GetAdminTimeDetails") {
                            e?.result?.forEach(element => {
                                if (element.clientName && /^[, ]+$/.test(element.clientName)) {
                                    element.clientName = "";  // Replace only if it contains only commas and spaces
                                }
                            }); 
                            
                           
                        }
                        if(url=="api/Client/GetServiceEvaluation")
                        {
                            e?.result?.forEach((element) => {
                                if (element.phone1 != null) {
                                  element.phone =
                                  element.phone1 != null
                                      ? this.general.reconverPhoneGoogleLibhttpsave(
                                        element.phone1
                                      )
                                      : null;
                                }
                                element.Name =
                                element.lastName + ", " + element.firstName;
                                element.Name =
                                ( element.lastName != null
                                  ?  element.lastName
                                  : "") +
                                " " +
                                (element.firstName != null
                                  ? element.firstName
                                  : "") 
                                if (element.reviewDate == "1/1/1") {
                                  element.reviewDate = "";
                                }
                                if (element.isAnsweredCall == true) {
                                  element.isAnsweredCall = "Yes";
                                } else if (element.isAnsweredCall == false) {
                                  element.isAnsweredCall = "No";
                                }
                                if (element.isPCAPresent == true) {
                                  element.isPCAPresent = "Yes";
                                } else if (element.isPCAPresent == false) {
                                  element.isPCAPresent = "No";
                                }
                              });
                        }

                        return e;
                    }))
    }
    //.............................CommonFunctionforPowerBiToken........................................
    // CommonFunctionforPowerBiToken() {
    //     let url = "api/Report/GetAccessToken"
    //     return new Promise((resolve, rejects) => {
    //         this.http.get(url).pipe(takeUntil(this.onDestroy$))
    //             .subscribe(
    //                 (data: any) => {
    //                     this.global.powerbiToken = data;
    //                     resolve(data);
    //                 },
    //                 (error: HttpErrorResponse) => {
    //                     resolve(error.message);
    //                 }
    //             );
    //     });
    // }
    //.............................getStateJson........................................
    getStateJson(): Observable<any> {
        let httpLocal = new HttpClient(this.handler);
        return httpLocal.get("./assets/states.json");
    }
     //.............................getDropDownList........................................
    async getDropDownList(ListCode: any, params, url, Type): Promise<any> {
        if (ListCode != undefined) {
            if (Type == "LovDropDown") {
                if (this.global.LovValues[ListCode] == undefined) {
                    await this.AssignDropDownList(ListCode, params, url, Type);
                }
                let output: any = JSON.parse(JSON.stringify(this.global.LovValues[ListCode]))
                return output;
            }
            // if (Type == "LocationDropDown") {
            //     if (this.global.LocationValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.LocationValues[ListCode]))
            //     return output;
            // }
            // if (Type == "ServiceDropDown") {
            //     if (this.global.ServiceValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.ServiceValues[ListCode]))
            //     return output;
            // }
            // if (Type == "PayorDropDown") {
            //     if (this.global.globalCommonGetGPList[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.globalCommonGetGPList[ListCode]))
            //     return output;
            // }

            // if (Type == "UserDropDown") {
            //     if (this.global.UserValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.UserValues[ListCode]))
            //     return output;
            // }
            // if (Type == "SDD") {
            //     if (this.global.ServiceDropDownValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.ServiceDropDownValues[ListCode]))
            //     return output;
            // }
            // if (Type == "MSDD") {
            //     if (this.global.MasterServiceDropDownValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.MasterServiceDropDownValues[ListCode]))
            //     return output;
            // }
            // if (Type == "CSDD") {
            //     if (this.global.CompanyDropDownValues[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.CompanyDropDownValues[ListCode]))
            //     return output;
            // }
            // if (Type == "SPDD") {
            //     if (this.global.ServicePayrateList[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.ServicePayrateList[ListCode]))
            //     return output;
            // }
            // if (Type == "GlobalLocation") {
            //     if (this.global.globalLoc[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.globalLoc[ListCode]))
            //     return output;
            // }
            // if (Type == "ClearingHouse") {
            //     if (this.global.globalClearinghouse[ListCode] == undefined) {
            //         await this.AssignDropDownList(ListCode, params, url, Type);
            //     }
            //     let output: any = JSON.parse(JSON.stringify(this.global.globalClearinghouse[ListCode]))
            //     return output;
            // }  
        }
    }

    get271Pdf(id: string) {
  return this.http.get(
    `api/Claims/Get271Details?id=${id}`,
    { responseType: 'blob' }
  );
}
GetFunctionwithResponseTypeBlob(params: URLSearchParams, url: string) {
  return this.http.get(
    `${url}${params.toString()}`,
    { responseType: 'blob' }
  );
}

     //.............................AssignDropDownList........................................
    AssignDropDownList(ListCode: any, params, url, Type) {
        return new Promise((resolve) => {
            this.http.get<any>(url + params).pipe().subscribe((data: any) => {
                if (Type == "LovDropDown") {
                    this.global.LovValues[ListCode] = data;
                }
                // if (Type == "LocationDropDown") {
                //     this.global.LocationValues[ListCode] = data;
                // }
                // if (Type == "ServiceDropDown") {
                //     this.global.ServiceValues[ListCode] = data;
                // }
                // if (Type == "PayorDropDown") {
                //     this.global.globalCommonGetGPList[ListCode] = data;
                // }
                // if (Type == "UserDropDown") {
                //     this.global.UserValues[ListCode] = data;
                // }
                // if (Type == "SDD") {
                //     this.global.ServiceDropDownValues[ListCode] = data;
                // }
                // if (Type == "MSDD") {
                //     this.global.MasterServiceDropDownValues[ListCode] = data;
                // }
                // if (Type == "CSDD") {
                //     this.global.CompanyDropDownValues[ListCode] = data;
                // }
                // if (Type == "SPDD") {
                //     this.global.ServicePayrateList[ListCode] = data;
                // }
                // if (Type == "GlobalLocation") {
                //     this.global.globalLoc[ListCode] = data;
                // }
                // if (Type == "ClearingHouse") {
                //     this.global.globalClearinghouse[ListCode] = data;
                // }
                resolve(data)
            })
        })
    }
    //  //.............................RefreshDropDownList........................................
    async RefreshDropDownList(ListCode, params, url, Type) {
        let output;
        await this.AssignDropDownList(ListCode, params, url, Type);
        if (Type == "LovDropDown") {
            output = JSON.parse(JSON.stringify(this.global.LovValues[ListCode]))
        }
        // if (Type == "LocationDropDown") {
        //     output = JSON.parse(JSON.stringify(this.global.LocationValues[ListCode]))
        // }
        // if (Type == "ServiceDropDown") {
        //     output = JSON.parse(JSON.stringify(this.global.ServiceValues[ListCode]))
        // }
        // if (Type == "PayorDropDown") {
        //     output = JSON.parse(JSON.stringify(this.global.globalCommonGetGPList[ListCode]))
        // }
        // if (Type == "UserDropDown") {
        //     output = JSON.parse(JSON.stringify(this.global.UserValues[ListCode]))
        // }
        // if (Type == "SDD") {
        //     output = JSON.parse(JSON.stringify(this.global.ServiceDropDownValues[ListCode]))
        // }
        // if (Type == "MSDD") {
        //     output = JSON.parse(JSON.stringify(this.global.MasterServiceDropDownValues[ListCode]))
        // }
        // if (Type == "CSDD") {
        //     output = JSON.parse(JSON.stringify(this.global.CompanyDropDownValues[ListCode]))
        // }
        // if (Type == "SPDD") {
        //     output = JSON.parse(JSON.stringify(this.global.ServicePayrateList[ListCode]))
        // }
        // if (Type == "GlobalLocation") {
        //     output = JSON.parse(JSON.stringify(this.global.globalLoc[ListCode]))
        // }
        // if (Type == "ClearingHouse") {
        //     output = JSON.parse(JSON.stringify(this.global.globalClearinghouse[ListCode]))
        // }
        return output;
    }
     //.............................ngOnDestroy........................................
    public ngOnDestroy(): void {
        this.onDestroy$.next();
    }
}
